module.exports = __webpack_public_path__ + "media/icons/download-google-play-f7001363.svg";